import $ from "jquery"
import * as bootstrap from 'bootstrap';

const scrollSpy = new bootstrap.ScrollSpy(document.body, {
  target: '#content',
  offset: 150
});

$('.section--content__mobile-heading').on('click', function () {
  $(this).toggleClass('active');
  $(this).next().toggleClass('d-none d-flex');
  let id = $(this).parent().attr('id')
  $('html, body').animate({
    scrollTop: $('#'+id).offset().top - 160
  }, 0);
});

$(window).on('load', function() {
  if(window.location.hash && $(window).width() < 769) {
    var hash = window.location.hash.substring(1);
    
    $('#'+hash).find('.section--content__mobile-heading').addClass('active').next().toggleClass('d-none d-flex')
  }
});